/**
 * The teamio.sites columns the browser loads into the `sites` store and localStorage
 * (Documents/OD-API-PLANNING.md Phase 0.2).
 *
 * Every column EXCEPT the secrets (TwilioAuthToken, TwilioAPIKey, TwilioAPISecret, ZapierAPIKey), in
 * table order, so each site row has the same shape as before minus those four. An allow-list on
 * purpose: a column added later (the encrypted Open Dental customer key, Phase 0.3) never reaches a
 * browser unless someone adds it here deliberately.
 *
 * Checked 2026-09-25: all 49 exist on dev (53 columns) and prod (56). Prod's three extra legacy
 * columns — indexes_created, default_providers_set, Paid — are read by no code in any repo, so they
 * are left out on purpose (and adding them would break the dev login, which lacks them).
 *
 * Every name must exist on the stage being queried: /runquery sends the login batch as ONE
 * multi-statement query, so an unknown column fails sites, employees, lists, settings and providers
 * together. Mirrors teamio-serverless-api main-service/sql/sites-client-columns.js (testLogin);
 * cypress/node-tests/sites-columns-no-secrets.test.js pins both.
 */
export const SITES_CLIENT_COLUMNS = Object.freeze([
  'SiteID', 'ClinicNum', 'CustomerID', 'Name', 'Active',
  'DeactivationStatus', 'DeactivationStep', 'DeactivationStartedAt', 'DeactivationScheduledAt',
  'DeactivationCompletedAt', 'DeactivationEventBridgeRule', 'DeactivationError', 'DeactivationRetryCount',
  'Address1', 'Address2', 'City', 'State', 'Zip', 'Country', 'RegionCode', 'OfficePhone',
  'DateCreated', 'DefaultDB', 'ExeVersion', 'ServerComputerName', 'AlertStatus', 'AlertTimestamp', 'LastPing',
  'StripeCustomerID', 'StripeSubscriptionStarted', 'TwilioAccountSID',
  'DataLoadingInProgress', 'AutoReload', 'BigSite', 'BigSiteSchemaLoaded', 'BigSiteTableCount', 'BigSiteTableCounter',
  'LogoUrl', 'DateFormat', 'PaymentProvider', 'StripeAccountId', 'IsHQOnly', 'PriSecProvInterchangeable',
  'LastEventPing', 'EventAlertStatus', 'EventAlertTimestamp', 'PipelineState', 'PipelineStateSince', 'PipelineStateDetail',
]);

export const SITES_CLIENT_SELECT = SITES_CLIENT_COLUMNS.join(', ');
